<template xmlns:v-bind="http://www.w3.org/1999/xhtml">
    <div class="content-bg" v-bind:class="{ second: isSecond }">
      <div class="content">

        <div class="img conpic" v-bind:class="{ 'img-second': isSecond }">
          <img v-bind:class="{ 'img-second': isSecond }" :src="imgurl"/>
        </div>

        <div class="detail" v-bind:class="{ text: !isSecond, 'text-second': isSecond }">
          <div>
            <span class="headline">{{slogan}}</span>

            <div class="description">
              <span><p>{{description}}</p></span>
            </div>
          </div>
        </div>
        
      <div class="clear"></div>
      </div>
      <div class="clear"></div>
    </div>
</template>

<script>
import $ from 'jquery'
  export default {
    name: 'homeStrengthIntro',
    props: ['isSecond', 'slogan', 'description', 'imgurl', 'keyword'],
    data () {
      return {
      }
    },
    created: function () {
      // this.animation()
      // window.addEventListener('scroll', this.animation())
    },
    mounted() {
      this.animation()
      window.addEventListener('scroll', this.animation)
    },
    methods: {
      animation: function () {
        let scrTop = document.body.scrollTop || document.documentElement.scrollTop
          // console.log('-------------' + scrTop)
        let winHei = document.body.clientHeight
          // console.log('-------------' + scrTop)
        let domTop = $('.conpic').offset().top
        var conp = document.getElementsByClassName('showPic')
        console.log(conp.length);
        $('.conpic').each(function () {
          let _this = $(this)
          let domTop = $(this).offset().top - scrTop
          console.log('-------------'  + domTop);
          if (domTop < 900) {
            _this.find('img').css({
              'left': '0px',
              'opacity': '1'
            });
          }
        })
        
      }
    }
  }
</script>

<style scoped>
/*@import url('../../../assets/animate.min.css');*/
.clear{
  clear: both;
}
  div.content-bg {
    width: 100%;
    display: block;
    margin: auto;
    background-color: rgb(255, 255, 255);
    color: rgb(73,73,73);
  }

  div.second {
    background-color: rgb(240, 246, 254);
  }

  .content {
    width: 980px;
    margin: 0 auto;
    height: 650px;
  }
  .hid{
    display: none;
  }
  .img {
    margin-top: 100px;
    height: 500px;
    line-height: 500px;
    float: left;
    width: 50%;
    position: relative;
  }
div.img img{
  float: left;
  margin-top: 40px;
  margin-left: 40px;
  position: absolute;
  opacity: 0;
  top: 0;
  left: 150px;
  transition:left 2s ease,opacity 2s ease;
  -moz-transition:left 2s ease,opacity 2s ease; /* Firefox 4 */
  -webkit-transition:left 2s ease,opacity 2s ease; /* Safari and Chrome */
  -o-transition:left 2s ease,opacity 2s ease; /* Opera */
  }
/*div.img img:hover{
  left: 0px;
  opacity: 0;
  }*/
  .detail {
    margin-top: 208px;
    margin-bottom: 50px;
  }
  div.text-second {
    float: left;
    margin-left: 40px;
  }

  div.img-second {
    float: right;
  }

  div.img-second img{
    float: right;
  }
  .headline {
    font-weight: normal;

    font-size: 48px;
    font-family: 'PingFangSC', "PingFang SC Semibold", "PingFang SC";
    font-style: normal;
    /*color: #1ebbe4;*/
  }

  .description {
    font-family: 'Helvetica', 'Helvetica';
    font-size: 24px;
    white-space: pre;
    width: 426px;
    margin-top: 35px;
    line-height: 60px;
  }

  .text {
    float: right;
    margin-left: 50px;
  }

  p {
    margin: auto;
    white-space: pre-line;
  }

  /*.emphasize {*/
    /*color: #FF0000;*/
  /*}*/

</style>



// WEBPACK FOOTER //
// HomeStrengthIntro.vue?64f259fb